<template>
  <div
    v-if="showChat"
    class="layout"
  >
    <SocialChat
      :attendants="attendants"
      class="whatsapp-chat"
    >
      <template v-slot:button="{ open }">
        <img
          src="/img/icons/whatsapp-white.png"
          alt="icon whatsapp"
          aria-hidden="true"
          width="32"
          height="32"
        >
      </template>

      <p slot="header">
        {{ $t('lang.wekeep_chat.header') }}
      </p>
      <!--      <small slot="footer">{{ $t('lang.wekeep_chat.footer') }}</small>-->
    </SocialChat>
  </div>
</template>

<script>
import getIPInfo from '@/components/CommonScripts/IPInfo';

export default {
  name: 'ChatButtons',
  data() {
    return {
      showChat: true,
      attendants: [
        {
          app: 'whatsapp',
          label: this.$t('lang.wekeep_chat.label'),
          name: 'WhatsApp',
          number: process.env.VUE_APP_WEKEEP_PHONE_NUMBER,
          avatar: {
            src: `${process.env.VUE_APP_URL}/img/icons/whatsapp.png`,
            alt: 'WhatsApp',
          },
        },
        {
          href: `/${this.$store.state.main.lang}/full-help`,
          label: this.$t('lang.wekeep_chat.title_faq'),
          name: this.$t('lang.wekeep_chat.faq'),
          avatar: {
            src: `${process.env.VUE_APP_URL}/img/icons/question.png`,
            alt: this.$t('lang.wekeep_chat.faq'),
          },
        },
      ],
    };
  },
  async created() {
    // No mostramos el chat en la busqueda para que no interfiera con el boton de reserva en movil
    if (this.$route.path === '/search') {
      this.showChat = false;
    }

    let country = null;
    if (this.$store.state.main.ipCountry) {
      country = this.$store.state.main.ipCountry;
    } else {
      country = await getIPInfo();
    }

    switch (country) {
      case 'MX':
        this.attendants[0].number = process.env.VUE_APP_WEKEEP_PHONE_NUMBER_MX;
        break;
      case 'CL':
        this.attendants[0].number = process.env.VUE_APP_WEKEEP_PHONE_NUMBER_CL;
        break;
      case 'AR':
        this.attendants[0].number = process.env.VUE_APP_WEKEEP_PHONE_NUMBER_AR;
        break;
      default:
        break;
    }
  },
};

</script>

<style scoped>

</style>
